import { $ } from "@/common/Axios";

export default {
  /**
   * APP版本管理
   */
  appVersion: {
    /*
     * 添加
     * channel 渠道 (string query )
     * content 版本更新消息 (string query )
     * deviceType 设备类型：安卓，苹果 (string query )
     * download 新版apk或补丁下载地址 (string query )
     * forceCheck 是否强制更新：是，否 (string query )
     * id  (integer query )
     * name APP名称 (string query )
     * title 更新标题 (string query )
     * versionCode 版本号 (integer query )
     * versionName 版本名称 (string query )
     */
    post: (p, c) => $.post("/api/bms/develop/appVersion", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/develop/appVersion", p, c),
  },
  appVersion_getAppVersion: {
    /*
     * 获取Ａｐｐ版本
     * channel 渠道 (string query )
     * deviceType 设备 (string query required)
     * name App名字 (string query required)
     */
    get: (p, c) => $.get("/api/bms/develop/appVersion/getAppVersion", p, c),
  },
  appVersion_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/develop/appVersion/list", p, c),
  },

  /**
   * 回调管理
   */
  callback_getBlackPhone: {
    /*
     * 获取手机号黑名单
     */
    get: (p, c) => $.get("/api/bms/develop/callback/getBlackPhone", p, c),
  },
  callback_handle: {
    /*
     * 处理
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/develop/callback/handle", p, c),
  },
  callback_listForCustomer: {
    /*
     * 客服回调列表
     */
    get: (p, c) => $.get("/api/bms/develop/callback/listForCustomer", p, c),
  },
  callback_listPlatform: {
    /*
     * 平台列表
     * tradeType 业务类型 (string query required)
     */
    get: (p, c) => $.get("/api/bms/develop/callback/listPlatform", p, c),
  },
  callback_listType: {
    /*
     * 类型列表
     * tradeType 业务类型 (string query required)
     */
    get: (p, c) => $.get("/api/bms/develop/callback/listType", p, c),
  },
  callback_setBlackPhone: {
    /*
     * 更新手机号黑名单
     * phones 手机号 (array query required)
     */
    put: (p, c) => $.put("/api/bms/develop/callback/setBlackPhone", p, c),
  },

  /**
   * 系统配置
   */
  config: {
    /*
     * 添加
     * configKey 键名 (string query )
     * configValue 键值 (string query )
     * id  (integer query )
     * remark 备注 (string query )
     * type 类型 (string query )
     */
    post: (p, c) => $.post("/api/bms/develop/config", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/develop/config", p, c),
  },
  config_getByKey: {
    /*
     * 根据key获取配置
     * key 键 (string query required)
     */
    get: (p, c) => $.get("/api/bms/develop/config/getByKey", p, c),
  },
  config_getConfigByKey: {
    /*
     * 获取字符串类型的值
     * key 键 (string query required)
     */
    get: (p, c) => $.get("/api/bms/develop/config/getConfigByKey", p, c),
  },
  config_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/develop/config/list", p, c),
  },
  config_listAllDataAdmin: {
    /*
     * 获取能查看所有数据管理员
     * path 请求路径 (string query required)
     */
    get: (p, c) => $.get("/api/bms/develop/config/listAllDataAdmin", p, c),
  },
  config_listByEducation: {
    /*
     * 列表-学历教育平台
     */
    get: (p, c) => $.get("/api/bms/develop/config/listByEducation", p, c),
  },
  config_listSelect: {
    /*
     * 选项列表
     * key 键 (string query )
     */
    get: (p, c) => $.get("/api/bms/develop/config/listSelect", p, c),
  },
  config_refreshCache: {
    /*
     * 刷新缓存
     */
    put: (p, c) => $.put("/api/bms/develop/config/refreshCache", p, c),
  },
  config_restore: {
    /*
     * 修复配置
     */
    post: (p, c) => $.post("/api/bms/develop/config/restore", p, c),
  },
  config_setAllDataAdmin: {
    /*
     * 设置能查看所有数据管理员
     * adminIds 管理员id列表 (array query required)
     * path 请求路径 (string query required)
     */
    put: (p, c) => $.put("/api/bms/develop/config/setAllDataAdmin", p, c),
  },

  /**
   * 数据修复
   */
  dataRepair_details: {
    /*
     * 详情
     * id ID (integer query required)
     */
    get: (p, c) => $.get("/api/bms/develop/dataRepair/details", p, c),
  },
  dataRepair_dispose: {
    /*
     * 处理修复
     * extraFileUrl 附件 (string query )
     * id id (integer query required)
     * operatorRemark 修复备注 (string query required)
     * operatorResult 修复结果,下拉 (string query required)
     */
    post: (p, c) => $.post("/api/bms/develop/dataRepair/dispose", p, c),
  },
  dataRepair_list: {
    /*
     * 列表-基础平台-开发管理
     */
    get: (p, c) => $.get("/api/bms/develop/dataRepair/list", p, c),
  },
  dataRepair_listForApply: {
    /*
     * 列表-基础平台-内部管理
     */
    get: (p, c) => $.get("/api/bms/develop/dataRepair/listForApply", p, c),
  },
  dataRepair_remove: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/develop/dataRepair/remove", p, c),
  },
  dataRepair_save: {
    /*
     * 添加
     * attachmentUrl 附件 (string query )
     * content 修复内容 (string query required)
     * dingDepartmentId 钉钉部门id (integer query required)
     * title 标题,16个字以内 (string query required)
     */
    post: (p, c) => $.post("/api/bms/develop/dataRepair/save", p, c),
  },
  dataRepair_sync: {
    /*
     * 同步
     * id instanceId (string query required)
     */
    put: (p, c) => $.put("/api/bms/develop/dataRepair/sync", p, c),
  },
  dataRepair_update: {
    /*
     * 编辑
     * attachmentUrl 附件 (string query )
     * content 修复内容 (string query required)
     * dingDepartmentId 钉钉部门id (integer query required)
     * id ID (integer query required)
     * title 标题,16个字以内 (string query required)
     */
    put: (p, c) => $.put("/api/bms/develop/dataRepair/update", p, c),
  },

  /**
   * 动态代码
   */
  dynamicCode: {
    /*
     * 添加
     * id  (integer query )
     * name 动态代码名称（与函数名称相同） (string query )
     * remark 备注 (string query )
     * rules 规则 (string query )
     * scriptContent 脚本内容 (string query )
     */
    post: (p, c) => $.post("/api/bms/develop/dynamicCode", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/develop/dynamicCode", p, c),
  },
  dynamicCode_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/develop/dynamicCode/details", p, c),
  },
  dynamicCode_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/develop/dynamicCode/list", p, c),
  },
  dynamicCode_refreshCache: {
    /*
     * 刷新缓存
     */
    put: (p, c) => $.put("/api/bms/develop/dynamicCode/refreshCache", p, c),
  },
  dynamicCode_testEval: {
    /*
     * 测试执行代码
     * id id (integer query required)
     * params 参数 (string query required)
     */
    post: (p, c) => $.post("/api/bms/develop/dynamicCode/testEval", p, c),
  },

  /**
   * 意见反馈
   */
  feedback: {
    /*
     * 添加
     * appName 应用名称 (string query )
     * content 内容 (string query )
     * id  (integer query )
     * imageOne 图片1 (string query )
     * imageThree 图片3 (string query )
     * imageTwo 图片2 (string query )
     * userId 用户id (integer query )
     */
    post: (p, c) => $.post("/api/bms/develop/feedback", p, c),
  },
  feedback_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/develop/feedback/list", p, c),
  },
  feedback_listAppName: {
    /*
     * 应用名称列表
     */
    get: (p, c) => $.get("/api/bms/develop/feedback/listAppName", p, c),
  },

  /**
   * 本地文件保存时间配置
   */
  localFileConfig: {
    /*
     * 添加
     * id  (integer query )
     * path 路径 (string query )
     * retainHours 保留时间(小时) (integer query )
     */
    post: (p, c) => $.post("/api/bms/develop/localFileConfig", p, c),
  },
  localFileConfig_removeLocalTempFiles: {
    /*
     * 临时-删除本地下载的一些文件
     * dir 目录 (string query )
     */
    put: (p, c) =>
      $.put("/api/bms/develop/localFileConfig/removeLocalTempFiles", p, c),
  },

  /**
   * 需求管理
   */
  requirement_detail: {
    /*
     * 详情
     * id id (integer query )
     */
    get: (p, c) => $.get("/api/bms/develop/requirement/detail", p, c),
  },
  requirement_export: {
    /*
     * 导出(开发管理-需求管理)
     */
    get: (p, c) => $.get("/api/bms/develop/requirement/export", p, c),
  },
  requirement_leaderUpdate: {
    /*
     * 编辑（项目负责人）
     * actualOnlineTime 实际上线时间 (string query )
     * docQiniuUrl 使用文档地址 (string query )
     * id id (integer query required)
     * preOnlineTime 预计交付时间 (string query )
     * preStartTime 预计开发开始时间 (string query )
     * remark 项目负责人备注 (string query )
     * step 阶段 (string query required)
     * urgencyLevel 紧急程度 (string query )
     */
    put: (p, c) => $.put("/api/bms/develop/requirement/leaderUpdate", p, c),
  },
  requirement_list: {
    /*
     * 列表(开发管理-需求管理)
     */
    get: (p, c) => $.get("/api/bms/develop/requirement/list", p, c),
  },
  requirement_listApplyDepartment: {
    /*
     * 登录人可添加需求部门列表， 为空则无添加权限
     */
    get: (p, c) =>
      $.get("/api/bms/develop/requirement/listApplyDepartment", p, c),
  },
  requirement_listForApply: {
    /*
     * 列表(内部管理-需求开发)
     */
    get: (p, c) => $.get("/api/bms/develop/requirement/listForApply", p, c),
  },
  requirement_listPartnerDepartment: {
    /*
     * 配合部门列表
     */
    get: (p, c) =>
      $.get("/api/bms/develop/requirement/listPartnerDepartment", p, c),
  },
  requirement_listRequirementDepartment: {
    /*
     * 简单需求部门列表
     */
    get: (p, c) =>
      $.get("/api/bms/develop/requirement/listRequirementDepartment", p, c),
  },
  requirement_remove: {
    /*
     * 删除-撤回和拒绝状态下
     * id ID (integer query )
     */
    delete: (p, c) => $.delete("/api/bms/develop/requirement/remove", p, c),
  },
  requirement_save: {
    /*
     * 添加
     * department 需求部门 (string query required)
     * description 具体开发内容 (string query required)
     * extraQiniuUrl 需求文档 (string query )
     * name 需求名称 (string query required)
     * partnerDepartments 其他配合部门，多选逗号隔开 (string query )
     * purpose 开发目的 (string query required)
     */
    post: (p, c) => $.post("/api/bms/develop/requirement/save", p, c),
  },
  requirement_update: {
    /*
     * 编辑
     * description 具体开发内容 (string query required)
     * extraQiniuUrl 需求文档 (string query )
     * id id (integer query )
     * name 需求名称 (string query required)
     * partnerDepartments 其他配合部门，多选逗号隔开 (string query )
     * purpose 开发目的 (string query required)
     */
    post: (p, c) => $.post("/api/bms/develop/requirement/update", p, c),
  },

  /**
   * 需求部门配置
   */
  requirementConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/develop/requirementConfig/list", p, c),
  },
  requirementConfig_listCopyReceiver: {
    /*
     * 抄送人列表
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/develop/requirementConfig/listCopyReceiver", p, c),
  },
  requirementConfig_save: {
    /*
     * 添加
     * applyId 需求申请人 (integer query required)
     * auditId 需求审核人 (integer query required)
     * copyReceiverIds 抄送人ID列表,逗号隔开 (array query )
     * department 部门名称 (string query required)
     * id id (integer query )
     */
    post: (p, c) => $.post("/api/bms/develop/requirementConfig/save", p, c),
  },
};
